export default __webpack_public_path__ + "static/media/bender.e90e5089.svg";